import styled, { css } from 'styled-components'
import Calendar from 'react-calendar'
import DatePicker from 'react-date-picker'

interface PickerWrapperProps {
  width: string
}
interface CalendarComponentProps {
  leftCalendar?: boolean
}
interface CalendarItemProps {
  styling: {
    borderRadius: string | number
    backgroundColor: string
    color: string
  }
}
interface SelectionTypeOptionProps {
  active?: boolean
}

interface DateInputProps {
  onBlur: (e: any) => void
  onKeyPress: (e: any) => void
  onChange: (e: any) => void
  display: any
  value: any
}

export const Container = styled.div`
  min-width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid var(--Neutral-Gray300);
  box-shadow: 0px 2px 12px -5px rgb(0 46 62 / 5%);
  border-radius: 4px;
  gap: 12px;
  padding: 8px 16px;
  background-color: #fff;
  font-size: 16px;
  color: #525b75;

  svg {
    width: 16px;
    top: -1px;
    position: relative;
  }
`

export const ClearDateButton = styled.button`
  all: unset;
  color: #0a5b8b;
  margin-top: 8px;
  cursor: pointer;
`

export const MainInputContainer = styled.div`
  position: relative;

  input {
    background: none;
    border: none;
    padding: 16px;
  }
`

export const PickerWrapper = styled.div<PickerWrapperProps>`
  ${({ width }) => css`
    transition: width 400ms linear;
    display: flex;
    overflow: hidden;
    width: ${width};
    top: 0;
    right: 10px;
  `}
`

export const ErrorLabel = styled.span`
  ${({ theme: { colors } }) => css`
    color: ${colors.red};
  `}
`
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ActionsContainer = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 15px 25px;
    border-top: 1px solid ${colors.darkGrey};
    i.icon {
      margin: 0 15px !important;
    }
    .react-date-picker--open .react-date-picker__wrapper {
      border: 1px solid ${colors.eveningLight};
    }
    input {
      outline: 0;
      border: 0;
    }
  `}
`
export const SidebarContainer = styled.aside`
  ${({ theme: { colors } }) => css`
    border-right: 1px solid ${colors.darkGrey};
    padding: 30px 10px;
    background-color: #fafcfc;
    ul {
      white-space: nowrap;
      padding: 0;
      list-style: none;
      li {
        margin-bottom: 10px;
        padding: 5px 60px 5px 10px;
      }
    }
  `}
`

export const CalendarComponent = styled(Calendar)<CalendarComponentProps>`
  ${({ leftCalendar, theme: { colors } }) => css`
    &&& {
      border: 0;
      border-right: ${leftCalendar ? `1px solid ${colors.darkGrey}` : 0};
      padding: 25px;
      min-width: 350px;
      .react-calendar__navigation {
        margin: 0;
      }
      .react-calendar__month-view__weekdays {
        padding: 15px 7px;
        abbr {
          text-decoration: none;
          font-weight: 400;
          color: #012d3e;
          text-transform: capitalize;
          font-size: 14px;
        }
      }
      .react-calendar__tile--hover {
        background-color: #fff;
      }
      .react-calendar__tile--now {
        background-color: #fff;
      }
      .react-calendar__tile--active {
        background-color: #fff;
      }
      .react-calendar__navigation button:enabled:focus {
        background-color: unset;
      }
      .react-calendar__navigation button:enabled:hover {
        background-color: ${colors.darkGrey};
      }
      .react-calendar__month-view .react-calendar__tile {
        padding: 0;
        margin-bottom: 3px;
        .custom {
          display: block;
          width: 100%;
          padding: 15px 10px;
        }
        abbr:not(.custom) {
          display: none;
        }
      }
    }
  `}
`

export const CalendarItem = styled.abbr<CalendarItemProps>`
  ${({ styling: { borderRadius, backgroundColor, color } }) => css`
    background-color: ${backgroundColor};
    color: ${color};
    border-radius: ${borderRadius};
  `}
`

export const DateInput = styled(DatePicker)<DateInputProps>`
  ${({ theme: { colors }, display }) => css`
    .react-date-picker__wrapper {
      display: ${display};
      border: 1px solid ${colors.darkGrey};
      padding: 10px 15px;
      border-radius: 6px;
      .react-date-picker__inputGroup {
        min-width: auto;
        padding: 0;
      }
    }
  `}
`

export const SelectionTypeOption = styled.li<SelectionTypeOptionProps>`
  ${({ active }) => css`
    background-color: ${active ? '#f5f7f8' : 'unset'};
    font-weight: ${active ? 400 : 300};
    border-radius: 3px;
    :hover {
      background-color: #f5f7f8;
      cursor: pointer;
    }
  `}
`

export const Input = styled.input`
  opacity: 1 !important;
  background-color: #fff !important;
  padding: 8px 16px !important;
  font-size: 16px;
  border: 1px solid var(--Neutral-Gray300);
  border-radius: 4px;
  ::-webkit-input-placeholder {
    font-size: 16px !important;
  }
`

export const Buttons = styled.div`
  display: flex;
`
